export const eventListenersHandler = () => {
  const originalAddEventListener = Element.prototype.addEventListener;
  const originalRemoveEventListener = Element.prototype.removeEventListener;

  // Create a map to store event listeners
  const eventListenerMap = new WeakMap<Element, Record<string, EventListener[]>>();

  Element.prototype.addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions,
  ) {
    if (!eventListenerMap.has(this)) {
      eventListenerMap.set(this, {});
    }

    const listeners = eventListenerMap.get(this)!;
    if (!listeners[type]) {
      listeners[type] = [];
    }

    listeners[type].push(listener as EventListener);
    originalAddEventListener.call(this, type, listener, options);
  };

  Element.prototype.removeEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | EventListenerOptions,
  ) {
    if (eventListenerMap.has(this)) {
      const listeners = eventListenerMap.get(this)![type];
      if (listeners) {
        const index = listeners.indexOf(listener as EventListener);
        if (index !== -1) {
          listeners.splice(index, 1);
        }
      }
    }
    originalRemoveEventListener.call(this, type, listener, options);
  };

  /**
   * Returns the event listeners for the given element.
   * @param {Element} element - The element to retrieve event listeners for.
   * @returns {Record<string, EventListener[]>} - Object with event types as keys and arrays of listeners as values.
   */
  window.getEventListeners = function (element: Element): Record<string, EventListener[]> {
    return eventListenerMap.get(element) || {};
  };
};
